import firebase from 'firebase/app'
import 'firebase/messaging'
import React from 'react'
import { connect } from 'react-redux'
import toaster from '../../main-ui/toast'
import { storeFCMToken, sendTokenToAPI } from '../../../action/firebase-actions'
import { detect } from 'detect-browser'
import { locationMessageSet } from '../../../action/location-message-actions'
import { sendNotification, addNotification } from '../../../action/notification-actions'
import { initializeApp, getApps, deleteApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { isSupported } from "firebase/messaging";

let sentToAPI = false
let tokenRequested = false
let messaging = null
let app;

const config = {
  apiKey: __FIREBASE_APIKEY__,
  authDomain: __FIREBASE_AUTH_DOMAIN__,
  databaseURL: __FIREBASE_DATABASE_URL__,
  projectId: __FIREBASE_PROJECT_ID__,
  appId: 135398073784008,
  storageBucket: __FIREBASE_STORAGE_BUCKET__,
  messagingSenderId: __FIREBASE_MESSAGING_SENDER_ID__
}

const browser = detect()

const firebaseValidBrowser = () => {
  let isValid = false
  switch (browser && browser.name) {
    case 'chrome':
      if (!browser.os.toLowerCase().includes('android')) {
        isValid = true
      }
      break
    case 'firefox':
      isValid = true
    case 'samsung':
      isValid = true
      break
    default:
      isValid = false
      break
  }

  return isValid
}

const isfireBaseValidBrowser = firebaseValidBrowser()

class Firebase extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      token: null,
      IpAddress: null,
      lastMessage: {},
      messageList: []
    }
    this.config = config;
    this.vapidKey = config.apiKey;
    this.messaging = null;
    this.tokenRequested = false;
    this.isFirebaseValidBrowser = true; // Replace with your actual validation logic
    this.isFirebaseValidBrowserCheck = true
    this.parseMessage = this.parseMessage.bind(this)
    window.addEventListener('beforeunload', () => {
      this.removeFirebase()
    })
  }

  componentWillUnmount() {
    sentToAPI = false
    tokenRequested = false
  }


  async checkBrowserCompatibility() {
    this.isFirebaseValidBrowser = await isSupported();
    if (!this.isFirebaseValidBrowser) {
      console.warn("This browser does not support Firebase Messaging.");
    }
  }


  componentDidMount() {
    $.getJSON('https://jsonip.com/?callback=?', data => {
      // console.log(JSON.parse(data))
      console.log('res', data.ip)
      const IpAddress = data.ip
      console.warn('got ip', IpAddress)
      this.setState({ IpAddress })
    })
    console.log('firevase mounted')
    sentToAPI = false
    console.log('should call')
    this.initializeFirebase()
    console.log('called')
  }

  deleteFirebaseToken = () => {
    if (messaging && this.props.firebase && this.props.firebase.fcmToken) {
      messaging.deleteToken(this.state.token)
      this.setState({ token: null })
      tokenRequested = false
    }
  }

  createOrUpdateImportUpdateNotification = (body, timeStamp) => {
    // Only display the inside notitification for Import KML file is its one of the browsers where the notifications
    // are not fully supported
    if (browser && (browser.name == 'edge' || browser.name == 'safari')) {
      let index = this.state.messageList.findIndex(n => {
        return n.MessageTypeId == 'UploadImport' && n.TimeStamp == timeStamp
      })

      if (index && index >= 0) {
        let updatedMessageList = [...this.state.messageList]
        let notification = updatedMessageList[index]
        notification.Body = body
        updatedMessageList[index] = notification
        this.setState({ messageList: updatedMessageList })
      } else {
        let stamp = timeStamp ? timeStamp : new Date().toUTCString()
        let notificationObj = {
          MessageTypeId: 'UploadImport',
          FromUserId: this.props.user.id,
          ToUserId: this.props.user.id,
          TimeStamp: stamp,
          Fullname: '',
          Read: false,
          Body: body,
          Title: 'Import File',
          Image: './asset/Basemap_Primary_Corp_Logo.png',
          Date: new Date(stamp).toLocaleString()
        }

        let updatedMessageList = [...this.state.messageList]
        updatedMessageList.push(notificationObj)
        this.setState({ messageList: updatedMessageList })

        toaster.baseMapNotification(notificationObj.Body, notificationObj.Title, {
          autoClose: 2000
        })
      }
    }
  }

  addPendingUserRequestToInbox = () => {
    if (this.props.auth && this.props.auth.token) {
      this.props.friendListSet().then(friendList => {
        let pending = friendList.filter(f => f.friendStatusId == 1)

        // Find and create any pending friend request notification that are waiting for a response
        if (pending && pending.length > 0) {
          pending.map(p => {
            if (p.userId != this.props.user.id && p.friendId == this.props.user.id) {
              //If the friend request notification is missing this method will add it to the inbox
              this.addFriendRequestNotification(
                p.friend.fullName,
                p.userId,
                p.friendId,
                p.effective,
                p.friend.imageProfileUrl
              )
            }
          })
        }
      })
    }
  }

  addFriendRequestNotification = (fromName, fromUserId, toUserId, timeStamp, imageProfileUrl) => {
    const from = '' + fromUserId
    const to = '' + toUserId
    let existingRequest = this.state.messageList.find(n => {
      return n.MessageTypeId == '1' && n.FromUserId == from && n.ToUserId == to
    })
    //If notification doesnt exist, add it.
    console.log('here', existingRequest)
    if (!existingRequest) {
      let notificationObj = {
        MessageTypeId: '1',
        FromUserId: from,
        ToUserId: to,
        TimeStamp: timeStamp ? timeStamp : new Date().toUTCString(),
        StatusId: '1',
        Fullname: fromName,
        Read: true,
        ProfileImageUrl: imageProfileUrl
      }

      this.parseMessage(notificationObj, notificationObj.Read)
    }
  }

  rejectFriendRequest = timeStamp => {
    let noti = null
    let notiIndex = null
    for (let i = 0; i < this.state.messageList.length; i++) {
      if (this.state.messageList[i] && this.state.messageList[i].TimeStamp == timeStamp) {
        noti = this.state.messageList[i]
        notiIndex = i
      }
    }

    if (noti) {
      this.sendFriendRequestResponse(Number(noti.FromUserId), 3)
        .then(resp => {
          // Update the current notification to display responded action
          if (resp.status == 200) {
            let updatedMessageList = [...this.state.messageList]
            noti.StatusId = -1
            updatedMessageList[notiIndex] = noti
            this.setState({ messageList: updatedMessageList })
          }
        })
        .catch(err => {
          console.log('Failed to reject friend request', err)
        })
    }
  }

  acceptFriendRequest = timeStamp => {
    let noti = null
    let notiIndex = null
    for (let i = 0; i < this.state.messageList.length; i++) {
      if (this.state.messageList[i] && this.state.messageList[i].TimeStamp == timeStamp) {
        noti = this.state.messageList[i]
        notiIndex = i
      }
    }

    if (noti) {
      this.sendFriendRequestResponse(Number(noti.FromUserId), 2)
        .then(resp => {
          // Update the current notification to display responded action
          if (resp.status == 200) {
            let updatedMessageList = [...this.state.messageList]
            noti.StatusId = -1
            updatedMessageList[notiIndex] = noti
            this.setState({ messageList: updatedMessageList })
          }
        })
        .catch(err => {
          console.log('Failed to accept friend request', err)
        })
    }
  }
  /* Pending = 1,
    Accepted = 2,
    Declined = 3,
    Removed = 4,
    Blocked = 5*/
  sendFriendRequestResponse = (userId, response) => {
    return new Promise((resolve, reject) => {
      this.props
        .friendListRespondRequest(userId, response)
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  markAsRead = timeStamp => {
    let updatedMessageList = [...this.state.messageList]
    updatedMessageList.map(m => {
      if (m.TimeStamp == timeStamp) {
        m.Read = true
      }
    })

    this.setState({ messageList: updatedMessageList })
  }

  removeMessage = timeStamp => {
    let updatedMessageList = this.state.messageList.filter(m => m.TimeStamp !== timeStamp)
    this.setState({ messageList: updatedMessageList })
  }

  deleteAllMessages = () => {
    this.setState({ messageList: [] })
  }

  /* FriendRequest = 1,Location = 2,LocationStart = 3,LocationEnd = 4,ObjectShare = 5, kmlimport = 6, invitetopro = 7*/
  sendNotification = (type, fromUserId, toUserId) => {
    let typeId = 1
    const notificationObj = {
      messageTypeId: typeId,
      fromUserId: fromUserId,
      toUserId: toUserId,
      timeStamp: new Date().toUTCString()
    }

    if (Number.isFinite(type)) {
      typeId = type
    } else {
      switch (type.toLowerCase()) {
        case 'invitetopro':
          typeId = 7
          notificationObj.messageTypeId = typeId
          notificationObj.fullname = this.props.user.fullName
          notificationObj.message = `${notificationObj.fullname
            } wants to share their location with you. Upgrade now to see their location.`
          break

        case 'kmlimport':
          typeId = 6
          notificationObj.messageTypeId = typeId
          break

        // case 'objectshare':
        // 	typeId = 5
        // 	notificationObj.messageTypeId = typeId
        // 	break

        case 'Locationend':
          typeId = 4
          notificationObj.messageTypeId = typeId
          break

        case 'locationstart':
          typeId = 3
          notificationObj.messageTypeId = typeId
          break

        case 'location':
          typeId = 2
          notificationObj.messageTypeId = typeId
          break

        default:
        case 'friendrequest':
          typeId = 1
          notificationObj.messageTypeId = typeId
          break
      }
    }
    return new Promise((resolve, reject) => {
      this.props
        .sendNotification(notificationObj)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  sendTokenToAPI = currentToken => {
    console.warn('send called')
    if (isfireBaseValidBrowser && !sentToAPI && this.props.auth && this.props.user && this.props.user.id) {
      console.warn('passed check')
      sentToAPI = true
      console.log('sending token')

      this.setTokenToServer(currentToken)
        .then(resp => {
          console.warn('success')
          sentToAPI = true
          this.props.storeFCMToken(resp.body)
        })
        .catch(err => {
          console.warn('failed to set token')
          console.log(`Error: ${err}`)
          sentToAPI = false
        })
    }
  }

  /* Pending = 1,
    Accepted = 2,
    Declined = 3,
    Removed = 4,
    Blocked = 5*/
  /*
   FriendRequest = 1,
        Location = 2,
        LocationStart = 3,
        LocationEnd = 4,
        ObjectShare = 5,
        KmlImport = 6,
        InviteToPro = 7,
        ActivityLogComment = 9,
        ActivityLogLike = 10,
        UserFollowing = 11,
        ActivityLogPost = 12
  */
  parseMessage = (data, alreadyRead) => {
    console.log('parsing')
    let message = null
    let autoClose = 3000
    switch (data.MessageTypeId) {
      case '1':
        if (data.StatusId == '1') {
          message = `${data.Fullname} sent you a friend request.`
        }
        if (data.StatusId == '2') {
          message = `${data.Fullname} accepted your friend request.`
        }
        if (data.StatusId == '3') {
          message = `${data.Fullname} declined your friend request.`
        }
        if (data.StatusId == '4') {
          message = `${data.Fullname} removed you from friends.`
        }
        if (data.StatusId == '5') {
          message = `${data.Fullname} blocked you.`
        }

        data.Title = 'Social'
        break
      case '2':
        // Do not display this notification as it will get annoying because its spamy
        // message = `${data.Fullname} is sharing a location`
        break
      case '3':
        data.Title = 'Localization'
        message = `${data.Fullname} is starting to share a location`
        break
      case '4':
        data.Title = 'Localization'
        message = `${data.Fullname} stopped sharing a location`
        break
      // case '5':
      //   data.Title = 'Objects'
      //   message = `${data.Fullname} is sharing an object`
      //   break
      case '6':
        data.Title = 'Import file'
        message = `${data.Message}`
        autoClose = false
        break
      case '7':
        data.Title = 'Upgrade to PRO'
        message = `${data.Message}`
        break

      // case '11':
      //   data.Title = 'Social'
      //   message = data.Message
      //   break
      default:
        break
    }

    data.Image = data.ProfileImageUrl ? data.ProfileImageUrl : './asset/Basemap_Primary_Corp_Logo.png'
    data.body = message
    data.date = new Date(data.TimeStamp).toLocaleString()
    data.timeStamp = data.TimeStamp
    console.log('get parsed')

    if (data.MessageTypeId === '2') {
      const { FromUserId } = data,
        locationMessageClone = [].concat(this.props.locationMessages)
      if (!locationMessageClone.some(message => message.FromUserId === FromUserId)) {
        locationMessageClone.unshift(data)
      } else {
        locationMessageClone.forEach(message => {
          if (message.FromUserId === FromUserId) {
            message = Object.assign(message, data)
          }
        })
      }
      this.props.locationMessageSet(locationMessageClone)
    }

    if (message) {
      this.props.addNotification(data)
      if (!alreadyRead) {
        toaster.baseMapNotification(message, data.Title, {
          autoClose: autoClose
        })
      }

      let updatedMessageList = [...this.state.messageList]
      updatedMessageList.push(data)
      updatedMessageList.sort((a, b) => b.Date - a.Date)
      this.setState({ lastMessage: data, messageList: updatedMessageList })
    }
  }


  // initializeFirebase = () => {
  //   console.log('Firebase apps:', getApps());
  //   if (this.isFirebaseValidBrowser) {
  //     if (getApps().length === 0) {
  //       console.log('Initializing Firebase...');
  //       initializeApp(this.config);
  //       console.log('Firebase initialized.');
  //     }

  //     if (!this.messaging) {
  //       this.messaging = getMessaging();
  //       console.log('Firebase Messaging initialized.');
  //     }

  //     this.requestToken();

  //     // Check token refresh manually by calling getToken periodically
  //     setInterval(() => {
  //       this.requestToken(); // Refresh the token periodically (e.g., every hour)
  //     }, 3600000); // 1 hour in milliseconds

  //     onMessage(this.messaging, (payload) => {
  //       console.log('Message received on focused window:', payload);
  //       this.parseMessage(payload.data, false);
  //     });
  //   }
  // };


  async initializeFirebase() {
    await this.checkBrowserCompatibility(); // Ensure compatibility check is done first
    console.log('Firebase apps:', getApps());

    if (this.isFirebaseValidBrowserCheck) {
      // Check if the browser supports Firebase Messaging
      const isMessagingSupported = await isSupported();
      if (!isMessagingSupported) {
        console.error('Browser does not support Firebase Messaging.');
        return;
      }

      if (getApps().length === 0) {
        console.log('Initializing Firebase...');
        initializeApp(this.config);
        console.log('Firebase initialized.');
      }

      if (!this.messaging) {
        this.messaging = getMessaging();
        console.log('Firebase Messaging initialized.');
      }

      this.requestToken();

      // Refresh the token periodically
      setInterval(() => {
        this.requestToken();
      }, 3600000); // 1 hour in milliseconds

      // Handle incoming messages
      onMessage(this.messaging, (payload) => {
        console.log('Message received on focused window:', payload);
        this.parseMessage(payload.data, false);
      });
    } else {
      console.warn('Firebase is not initialized due to invalid browser environment.');
    }
  };



  requestToken = async () => {
    console.log('req token')
    if (!this.tokenRequested && this.isFirebaseValidBrowser) {
      this.tokenRequested = true;
      try {
        console.log('Requesting permission...');
        const currentToken = await getToken(this.messaging, { vapidKey: this.vapidKey });
        if (currentToken) {
          console.log('Got token:', currentToken);
          this.setTokenToServer(currentToken);
        } else {
          console.log('No token available. Request permission to generate one.');
        }
      } catch (err) {
        console.error('Error while retrieving token:', err);
        this.tokenRequested = false;
      }
    }
  };

  removeFirebase = () => {
    console.log('Removing Firebase...');
    getApps().forEach(async (app) => {
      await deleteApp(app);
    });
    navigator.serviceWorker.getRegistrations().then((workers) => {
      workers.forEach((worker) => worker.unregister());
    });
  };

  setTokenToServer = (token) => {
    console.log('set token')
    const firebaseObj = {
      deviceId: `${this.state.IpAddress}+${this.props.user.id}`,
      fcmToken: token,
    };

    return new Promise((resolve, reject) => {
      this.props
        .sendTokenToAPI(firebaseObj)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  parseMessage = (data, flag) => {
    // Your logic for handling messages
    console.log('Parsing message:', data, flag);
  };

  render() {
    const { children } = this.props
    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        initializeFirebase: this.initializeFirebase,
        removeFirebase: this.removeFirebase,
        sendNotification: this.sendNotification,
        lastMessage: this.state.lastMessage,
        messageList: this.state.messageList,
        markAsRead: this.markAsRead,
        rejectFriendRequest: this.rejectFriendRequest,
        acceptFriendRequest: this.acceptFriendRequest,
        sendFriendRequestResponse: this.sendFriendRequestResponse,
        addPendingUserRequestToInbox: this.addPendingUserRequestToInbox,
        createOrUpdateImportUpdateNotification: this.createOrUpdateImportUpdateNotification,
        deleteFirebaseToken: this.deleteFirebaseToken,
        removeMessage: this.removeMessage,
        deleteAllMessages: this.deleteAllMessages
      })
    )

    return (
      <React.Fragment>
        {!this.props.auth ? (sentToAPI = false) : null}
        {this.props.auth && this.state.token && !sentToAPI ? this.sendTokenToAPI(this.state.token) : null}
        {childrenWithProps}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  firebase: state.firebase,
  user: state.user,
  notifications: state.notifictaions,
  locationMessages: state.locationMessage,
  locationSharing: state.locationSharing
})

const mapDispatchToProps = dispatch => ({
  storeFCMToken: token => dispatch(storeFCMToken(token)),

  addNotification: message => dispatch(addNotification(message)),
  locationMessageSet: messages => dispatch(locationMessageSet(messages)),


  sendTokenToAPI: fireBaseObj => dispatch(sendTokenToAPI(fireBaseObj)),
  sendNotification: notificationObj => dispatch(sendNotification(notificationObj))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Firebase)

export { messaging }
